import { takeLatest, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { aiApi } from "../api";
import { showToast } from "../../../utils/showToast";

export const SET_LOADING = "saga/SET_LOADING";
export const SET_MESSAGE = "saga/SET_MESSAGE";
export const SET_ERROR = "saga/SET_ERROR";
export const SET_STATUS = "saga/SET_STATUS";

export const CREATE_CHAT_SESSION = "saga/CREATE_CHAT_SESSION";
export const OPEN_CHAT_SESSION = "saga/OPEN_CHAT_SESSION";

export const FETCH_CHAT_DATA_SUCCESS = "saga/FETCH_CHAT_DATA_SUCCESS";
export const FETCH_CONVERSATIONS_SUCCESS = "saga/FETCH_CONVERSATIONS_SUCCESS";
export const FETCH_SESSION_SUCCESS = "saga/FETCH_SESSIONS_SUCCESS";
export const FETCH_HISTORY_SUCCESS = "saga/FETCH_HISTORY_SUCCESS";

export const SEND_PROMPT = "saga/SEND_PROMPT";
export const SEND_FEEDBACK = "saga/SEND_FEEDBACK";
export const SEND_FEEDBACK_SUCCESS = "saga/SEND_FEEDBACK_SUCCESS";
export const RESET_CHAT = "saga/RESET_CHAT";

const actionCreators = {
  createChatSession: createAction(CREATE_CHAT_SESSION),
  openChatSession: createAction(OPEN_CHAT_SESSION),
  sendMessage: createAction(SEND_PROMPT),
  sendFeedback: createAction(SEND_FEEDBACK),
  resetChat: createAction(RESET_CHAT)
};

export const { openChatSession, createChatSession, sendMessage, sendFeedback, resetChat } =
  actionCreators;

export default function* watchAI() {
  yield takeLatestSafe(CREATE_CHAT_SESSION, createSession);
  yield takeLatestSafe(OPEN_CHAT_SESSION, openSession);
  yield takeLatestSafe(SEND_PROMPT, sendPrompt);
  yield takeLatest(SEND_FEEDBACK, fetchSendFeedback);
}

function takeLatestSafe(action, effect) {
  return takeLatest(action, tryCatch(effect));
}

function tryCatch(effect) {
  return function* (args) {
    try {
      yield call(effect, args);
    } catch (err) {
      console.error(err);
      const errorData =
        err.response && err.response.data
          ? err.response.data
          : { error: "Something went wrong. Please try again." };
      yield put({ type: SET_ERROR, payload: errorData });
      yield put({ type: SET_LOADING, payload: false });
    }
  };
}

function* openSession({ payload }) {
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: RESET_CHAT });

  const { data } = yield call(aiApi.getChatHistory, payload.id);

  yield put({
    type: FETCH_HISTORY_SUCCESS,
    payload: { ...payload, ...data }
  });
  yield put({ type: SET_LOADING, payload: false });
}

function* createSession({ payload } = {}) {
  const { pageName, filter } = payload || {};

  yield put({ type: SET_LOADING, payload: true });

  const { data } = yield call(aiApi.getSessionId, pageName, filter);

  if (!pageName) {
    yield put({ type: RESET_CHAT });
    yield getConversations();
  }

  yield put({ type: FETCH_SESSION_SUCCESS, payload: data });
  yield put({ type: SET_LOADING, payload: false });
}

function* sendPrompt({ payload }) {
  const { message, pageName, filter } = payload;
  const { session_id } = yield select((state) => state.ai.currentSession);

  yield put({ type: SET_MESSAGE, payload: { who: "user", response: message, session_id } });

  yield put({ type: SET_LOADING, payload: true });

  const { data } = yield call(aiApi.sendPrompt, { message, session_id, ...filter }, pageName);

  yield put({ type: SET_MESSAGE, payload: data });
  yield put({ type: SET_LOADING, payload: false });

  if (!pageName) {
    yield getConversations();
  }
}

function* getConversations() {
  const { data } = yield call(aiApi.getConversation);
  yield put({ type: FETCH_CONVERSATIONS_SUCCESS, payload: data });
}

function* fetchSendFeedback({ payload }) {
  try {
    const { id, feedback, pageName, filter, feedbackText } = payload;

    const res = yield call(
      aiApi.sendFeedback,
      id,
      { feedback, feedbackText, ...filter },
      pageName,
      filter
    );
    yield put({ type: SEND_FEEDBACK_SUCCESS, payload: { id, feedback } });
    showToast(res.data.status, 2000, "success");
  } catch {
    showToast("Failed to send feedback. Please try again.", 2000, "error");
  }
}
